import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import reportWebVitals from "./reportWebVitals";
import ReactGA from "react-ga4";

import {
  isMultiColorActive,
  defaultColor,
  isDarkSwitchActive,
} from "./constants/defaultValues";
// import "./assets/css/sass/themes/gogo.light.purplemonster.scss";
import { getCurrentColor, setCurrentColor } from "./helpers/Utils";
import { ENV } from "./config/ENV";
const color =
  isMultiColorActive || isDarkSwitchActive ? getCurrentColor() : defaultColor;
setCurrentColor(color);

ReactGA.initialize(ENV.google_analytics_id);

ReactDOM.render(
  <BrowserRouter basename="/">
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);
reportWebVitals();
